<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form-model @keydown.enter.native="searchQuery" @submit.native.prevent layout="inline">
        <a-row :gutter="24">
          <a-col :span="5">
            <a-form-model-item label="供水流域">
              <j-dict-select-tag
                @change="searchQuery"
                dictCode="`iwt-wf`.dev_process,process_name,id"
                placeholder="请选择供水流域"
                v-model="queryParam.devProcessId"
              />
            </a-form-model-item>
          </a-col>

          <a-col :span="5">
            <a-form-model-item label="设备类型">
              <j-tree-select-custom
                @change="handleClassChange"
                column="dev_class_code"
                dict="`iwt-wf`.dev_class,type_name,id"
                hasChildField="has_child"
                order="sort_no asc"
                pidValue="-1"
                placeholder="请选择设备类型"
                ref="treeSelect"
                returnKey="dev_class_code"
                v-model="queryParam.devClassCode"
              />
              <!--  hasChildField="has_child" -->
            </a-form-model-item>
          </a-col>
          <a-col :span="5">
            <a-form-model-item label="设备型号">
              <a-select
                :default-active-first-option="false"
                :filter-option="false"
                @change="searchQuery"
                allowClear
                placeholder="请选择设备型号"
                show-search
                v-model="queryParam.devTypeId"
              >
                <a-select-option :key="d.id" v-for="d in devModelList">{{ d.modelName }}</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="5">
            <a-form-model-item label="设备名称">
              <a-input placeholder="请输入设备名称" v-debounce="searchQuery" v-model="queryParam.devName"></a-input>
            </a-form-model-item>
          </a-col>

          <a-col :md="3" :sm="5">
            <span class="table-page-search-submitButtons" style="float: left;overflow: hidden;">
              <a-button @click="searchQuery" @keyup.enter.native="searchQuery" icon="search" type="primary">查询</a-button>
              <!-- <a-button html-type="submit" type="primary">查询</a-button> -->
              <a-button @click="searchReset" icon="reload" style="margin-left: 8px" type="primary">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form-model>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="batchDownLoadQRCode()" icon="download" type="primary">批量导出</a-button>
      <a-button @click="batchCreateDevQrCode()" icon="plus" type="primary">批量生成</a-button>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a @click="onClearSelected" style="margin-left: 24px">清空</a>
      </div>

      <a-table
        :columns="columns"
        :customRow="customRowRender"
        :dataSource="dataSource"
        :loading="loading"
        :pagination="ipagination"
        :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :scroll="{ x: true }"
        @change="handleTableChange"
        bordered
        class="j-table-force-nowrap"
        ref="table"
        rowKey="id"
        size="middle"
      >
        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无图片</span>
          <img
            :src="getImgView(text)"
            alt
            height="25px"
            preview
            style="max-width:80px;font-size: 12px;font-style: italic;"
            v-else
          />
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无文件</span>
          <a-button @click="downloadFile(text)" icon="download" size="small" type="primary" v-else>下载</a-button>
        </template>
        <span slot="action" slot-scope="text, record">
          <a-button @click="downloadQRCode(record)" icon="download" type="primary"></a-button>
        </span>
      </a-table>
    </div>
  </a-card>
</template>

<script>
  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import { getAction, postAction } from '../../../../api/manage'
  import { DragTableMixin } from '@/mixins/DragTableMixin'
  import { omit } from 'lodash'
  import { httpAction } from '@/api/manage'
  import { filterDictTextByCache } from '@/components/dict/JDictSelectUtil'
  import JTreeSelectDevice from '@/components/jeecg/JTreeSelectDevice'
  import { axios } from '@/utils/request'
  import moment from 'moment'

  export default {
    name: 'DevListList',
    mixins: [DragTableMixin, JeecgListMixin, mixinDevice],
    components: {
      JTreeSelectDevice
    },
    data () {
      return {
        description: '设备台账管理页面',
        // 表头
        columns: [
          {
            title: '设备名称',
            align: 'center',
            dataIndex: 'devName',
            sorter: true
          },

          {
            title: '表号',
            align: 'center',
            dataIndex: 'devTag',
            sorter: true
          },

          {
            title: '设备类型',
            align: 'center',
            dataIndex: 'devClassId_dictText',
            sorter: true
          },
          {
            //devTypeId_dictText
            title: '设备型号',
            align: 'center',
            dataIndex: 'devTypeId_dictText',
            sorter: true
          },

          {
            title: '设备状态',
            align: 'center',
            dataIndex: 'serviceStatus',
            customRender: function (text) {
              //dev_life_status
              return filterDictTextByCache('dev_life_status', text)
            },
            sorter: true
          },
          {
            title: '二维码',
            align: 'center',
            dataIndex: 'qrcode',
            width: 100,
            scopedSlots: { customRender: 'imgSlot' }
          },
          {
            title: '操作',
            dataIndex: 'action',
            align: 'center',
            // fixed: 'right',
            width: 147,
            scopedSlots: { customRender: 'action' }
          }
        ],
        isorter: {
          column: 'sort',
          order: 'asc'
        },
        queryParam: {
          devName: '',
          devClassId: '',
          parentId: ''
        },
        url: {
          list: '/device/devList/list',
          delete: '/device/devList/delete',
          deleteBatch: '/device/devList/deleteBatch',
          exportXlsUrl: '/device/devList/exportXls',
          importExcelUrl: 'device/devList/importExcel',
          sort: '/device/devList/editSort',
          add: '/device/devList/add',
          batchCreateDevQrCode: '/device/devList/batchCreateDevQrCode'
        },
        listPagination: {
          pageSize: 50,
          pageSizeOptions: ['50', '100', '200', '300']
        },
        modelSettings: {
          name: '设备型号',
          displayKey: 'modelName',
          valueKey: 'id',
          returnKeys: ['id', 'modelName'],
          listUrl: '/device/devModel/list',
          queryParamCode: 'modelName',
          queryParamText: '设备型号',
          columns: [
            { title: '型号名称', dataIndex: 'modelName', align: 'center' },
            // devCode

            {
              title: '型号编码',
              align: 'center',
              dataIndex: 'modelCode'
            },
            {
              title: '运行寿命',
              align: 'center',
              dataIndex: 'runningLife'
            }
          ]
        },
        dictOptions: {},
        superFieldList: [],
        devModelList: [],
        detailRouteName: 'FusionDevice',
        pageType: 1,
        deviceAddAttr: {
          devName: 'name',
          devTag: '2',
          parentId: '1538171098930270209',
          devClassId: '6A9OC55DC4D4467CA23DEF1CE37B0059',
          devProcessId: '1521373906911895553',
          areaId: '1521415028513701890',
          serviceStatus: '1'
        }
      }
    },
    created () {
      this.getSuperFieldList()
    },
    computed: {
      importExcelUrl: function () {
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
      }
    },
    methods: {
      // 打印 列表切换
      handlePrint () {
        this.pageType = !this.pageType
      },
      async handleModeQuery () {
        if (this.queryParam.devTypeId) this.queryParam.devTypeId = ''
        this.devModelList = []

        const { success, result } = await getAction('/device/devModel/queryByDevClassId', {
          devClassCode: this.queryParam.devClassCode
        })
        if (success) {
          this.devModelList = result
        }
      },
      handleClassChange (v) {
        this.handleModeQuery(v)
        this.searchQuery()
      },

      initDictConfig () { },
      getSuperFieldList () {
        let fieldList = []
        // fieldList.push({ type: 'string', value: 'devName', text: '设备名称' })
        // fieldList.push({ type: 'string', value: 'devCode', text: '设备名称' })
        // fieldList.push({ type: 'string', value: 'devTag', text: '表号' })
        // fieldList.push({ type: 'int', value: 'parentId', text: '父设备ID' })
        // fieldList.push({ type: 'string', value: 'devClassId', text: '设备类型ID' })
        // fieldList.push({ type: 'int', value: 'devTypeId', text: '设备型号ID' })
        // fieldList.push({ type: 'string', value: 'areaId', text: '所属区域' })
        // fieldList.push({ type: 'string', value: 'serviceStatus', text: '服役状态' })
        // fieldList.push({ type: 'date', value: 'operationDate', text: '投运日期' })
        // fieldList.push({ type: 'date', value: 'retireDate', text: '报废日期' })
        // fieldList.push({ type: 'string', value: 'qrcode', text: '二维码' })
        // fieldList.push({ type: 'string', value: 'pictureObjId', text: '设备照片(OSS服务对象ID)' })
        // fieldList.push({ type: 'int', value: 'runningLife', text: '运行寿命(天)' })
        // fieldList.push({ type: 'int', value: 'tenantId', text: '租户id' })
        // fieldList.push({ type: 'string', value: 'orgId', text: '公司id' })
        // fieldList.push({ type: 'int', value: 'delFlag', text: '删除状态' })
        this.superFieldList = fieldList
      },
      handleDetail (record) {
        this.$bus.$emit('to-page-detail', {
          name: 'FusionDevice',
          id: record.id,
          type: 'drawer'
        })
      },
      batchCreateDevQrCode () {
        getAction(this.url.batchCreateDevQrCode).then(res => {
          if (res.success) {
            this.loadData()
          } else {
            this.$message.error(res.message)
          }
        })
      },
      batchDownLoadQRCode (fileName) {
        if (!fileName || typeof fileName !== 'string') {
          fileName = moment(new Date(), 'YYYY-MM-DD').format('YYYY-MM-DD') + '-qrcode-exp'
        }
        if (this.selectedRowKeys.length <= 0) {
          this.$message.warning('请选择一条记录！')
        } else {
          var that = this
          const selectData = that.selectionRows.map(rows => omit(rows, ['id']))
          axios({
            url: '/device/devList/batchDownLoad',
            data: selectData,
            method: 'post',
            responseType: 'blob'
          })
            .then(data => {
              if (!data) {
                this.$message.warning('文件下载失败')
                return
              }
              if (typeof window.navigator.msSaveBlob !== 'undefined') {
                window.navigator.msSaveBlob(new Blob([data], { type: 'application/octet-stream' }), fileName)
              } else {
                let url = window.URL.createObjectURL(new Blob([data], { type: 'application/octet-stream' }))
                let link = document.createElement('a')
                link.style.display = 'none'
                link.href = url
                link.setAttribute('download', fileName + '.zip')
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link) // 下载完成移除元素
                window.URL.revokeObjectURL(url) // 释放掉blob对象
              }
            })
            .finally(() => {
              that.loading = false
            })
        }
      },
      handleCopyData (record) {
        this.copyData = record
      },
      // 复制
      handleCopy (records) {
        const that = this
        const selectData = omit(records, ['id'])

        postAction(that.url.add, selectData)
          .then(res => {
            if (res.success) {
              // 重新计算分页问题
              that.reCalculatePage(that.selectedRowKeys.length)
              that.$message.success('复制成功')
              that.loadData()
              that.onClearSelected()
            } else {
              that.$message.warning(res.message)
            }
          })
          .finally(() => {
            that.loading = false
          })
      },
      downloadQRCode (record) {
        //   let url = record.qrcode
        //   axios.get(url, { responseType: 'blob' })
        //     .then(res => {
        //       const blob = new Blob([res])
        //       const link = document.createElement('a')
        //       link.href = URL.createObjectURL(blob)
        //       link.download = record.devName + '.png';
        //       link.click()
        //       URL.revokeObjectURL(link.href);
        //     })
        //     .catch(console.error);
        axios({
          url: '/device/devList/downLoadQrcode',
          data: record,
          method: 'post',
          responseType: 'blob'
        })
          .then(data => {
            if (!data) {
              this.$message.warning('文件下载失败')
              return
            }
            let fileName = record.devName ? record.devName : record.id
            if (typeof window.navigator.msSaveBlob !== 'undefined') {
              window.navigator.msSaveBlob(new Blob([data], { type: 'application/octet-stream' }), fileName)
            } else {
              let url = window.URL.createObjectURL(new Blob([data], { type: 'application/octet-stream' }))
              let link = document.createElement('a')
              link.style.display = 'none'
              link.href = url
              link.setAttribute('download', fileName + '.jpg')
              document.body.appendChild(link)
              link.click()
              document.body.removeChild(link) // 下载完成移除元素
              window.URL.revokeObjectURL(url) // 释放掉blob对象
            }
          })
          .finally(() => { })
      }
    }
  }
</script>
<style scoped>

  @import '~@assets/less/common.less';

</style>
